
export enum ReceptionDateKinds {
  ReceptionDate = 1,
  CreateDate = 2,
  UpdateDate = 3,
  LimitDate = 4,
  FinishDate = 5,
  DeliveryLimitDate = 6,
  ReceiptDate = 7,
}

export class ReceptionDateKindsName {

  static getDisplayName(value: ReceptionDateKinds) {
    if (value === ReceptionDateKinds.ReceptionDate) { return "受付日"; }
    if (value === ReceptionDateKinds.CreateDate) { return "依頼登録日"; }
    if (value === ReceptionDateKinds.UpdateDate) { return "最終更新日"; }
    if (value === ReceptionDateKinds.LimitDate) { return "締切日"; }
    if (value === ReceptionDateKinds.FinishDate) { return "完了日"; }
    if (value === ReceptionDateKinds.DeliveryLimitDate) { return "交付期限"; }
    if (value === ReceptionDateKinds.ReceiptDate) { return "受取日"; }

    return "";
  }
}
